import React, { useEffect } from "react";
import axios from "axios";
// import getTermsByVocabCode from "../../components/helpers/global/term/term";
import config from "../../next.config.js";
import {encryption,decrypt } from "../helpers/helpers";
import Cookie from 'js-cookie'
import {getTermsByVocabCodes} from '../helpers/global/term/term'
// import {queryClient} from '../../react-query-config/queryClient'
import {dehydrate,useQuery} from '@tanstack/react-query'
export default function Statistics(props) {
  // console.log("queryClient=========>",dehydrate(queryClient))
  const info=useQuery({queryKey:["view-types","statistic-entities"],queryFn:async()=>JSON.parse(await getTermsByVocabCodes(["view-types","statistic-entities"]))})
  // console.log("info========>",info)
  useEffect(() => {
    // let dehydrateAppTerms=dehydrate(queryClient).queries.filter(ele=>ele.queryKey=="app-terms")[0].state.data
    // getTermsByVocabCodes(["view-types","statistic-entities"]).then(termRes=>{

      if(info.data){

     
        let sponsor =info.data.filter(ele=>ele.vocCode=="view-types").filter(i => i.code == "free");
        
            let statisticEntities =info.data.filter(ele=>ele.vocCode=="statistic-entities").filter(
              i => i.code == props.statisticsCode 
            );
            if(statisticEntities.length>0&&statisticEntities[0].id){
           
            let data = 
              {
                entityId: props.entityId,
                statisticEntityClassTypeId: statisticEntities[0].id,
                viewTypeId: sponsor[0].id,
                note: "post Statistic from web",
                date:new Date().getTime()
              }
            ;
              if(Cookie.get(encryption("uuid"))){
                data.serialNumber=decrypt(Cookie.get(encryption("uuid")))
              }
            if (Cookie.get(encryption("sponsor")) == "230244") {
              sponsor = JSON.parse(res).filter(i => i.code == "sponsor-search");
              data.viewTypeId=sponsor[0].id
            }

            axios({
              method: "POST",
              url: `${config["basePath"]}/api/statistics/add`,
              headers: {
                "Content-Type": "application/json"
              },
              data: [data]
            })
              .then(res => {
                // console.log("res=========>",res)
            if(res.data&&res.data.data&&res.data.data.successful.count>0){
                
                Cookie.remove(encryption("sponsor"))
            }
            })
              .catch(err => (err));
            }
          }
                // })
  
  }, []);
  return <></>;
}
